import {
  WSCard,
  WSDataItem,
  WSDivider,
  WSElement,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSTableItem,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubWorkLog } from "../../types";

const columns: WSTableColumn<PaystubWorkLog>[] = [
  {
    config: { header: { text: "Worklog" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => <WSTableCell text={data.label} />
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: ({ data }) => (
      <WSTableCell text={formatMoney(data.amount, Currency.USD)} />
    )
  }
];

type Props = {
  workLogs: PaystubWorkLog[];
  workLogsTotal: number;
  onWorkLogOpen?: (id: string) => void;
};

export const PaystubWorkLogsCard: React.FC<Props> = ({
  workLogs,
  workLogsTotal,
  onWorkLogOpen
}) => {
  const tableData: WSTableItem<PaystubWorkLog>[] = workLogs.map(workLog => ({
    id: workLog.id,
    data: workLog
  }));

  return (
    <WSElement>
      <WSSectionToolbar title="Work logs" />
      <WSCard mt="M">
        <WSList gap="M">
          <WSInfoBox>
            <WSText.ParagraphSm color="gray600">
              These are the work logs included in this paystub. To make changes
              to a work log, go to its work log details page.
            </WSText.ParagraphSm>
          </WSInfoBox>

          <WSTable<PaystubWorkLog>
            columns={columns}
            tableData={tableData}
            onRowClick={item => onWorkLogOpen?.(item.id)}
          />

          <WSDivider />

          <WSDataItem
            label="Total amount"
            value={formatMoney(workLogsTotal, Currency.USD)}
          />
        </WSList>
      </WSCard>
    </WSElement>
  );
};
